export default {
  modelName: 'date_format',
  label: '日期時間格式',
  fields: {
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    name: {
      label: '名稱',
      type: 'text',
      width: '300px',
      readonly: true,
    },
    value: {
      label: 'value',
      type: 'text',
      rules: 'required',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          width: '300px',
          rules: 'required',
          maxlength: 100,
        },
      },
    },
    is_active: {
      type: 'switch',
      label: '啟用',
      defaultValue: true,
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};